import { useEffect, useState } from 'react';
export function useSearchParams(param) {
    const [value, setValue] = useState(null);
    useEffect(() => {
        const urlSearchParams = new URLSearchParams(window.location.search);
        setValue(urlSearchParams.get(param));
    }, [param]);
    return [
        value,
        (newVal) => {
            const url = new URL(window.location.href);
            url.searchParams.set(param, newVal);
            window.history.pushState({}, '', url);
            setValue(newVal);
        },
    ];
}
